import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { fetchData } from "../helper/api.interceptor"; // adjust the path as per your project structure
import { useNavigate } from "react-router-dom";
const ProductDetails = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            try {
                const response = await fetchData.get("product/products");
                console.log("Fetched products:", response.result); // check the structure
                if (response && response.result) {
                    setProducts(response.result || []); // <- use the actual array
                }
            } catch (error) {
                console.error(error);
                Swal.fire("Error", "Failed to fetch products", "error");
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, []);
    const filteredProducts = products.filter((product) =>
        product.product_name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedProducts = filteredProducts.slice(
        startIndex,
        startIndex + itemsPerPage
    );

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const handleDeleteProduct = async (productId) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                const response = await fetchData.delete(`product/delete/${productId}`);

                if (!response || response.status_code !== 200) {
                    throw new Error(response?.message || "Failed to delete product");
                }

                setProducts((prev) =>
                    prev.filter((product) => product.product_id !== productId)
                );
                Swal.fire("Deleted!", "Product deleted successfully.", "success");
            } catch (error) {
                console.error(error);
                Swal.fire("Error!", "Failed to delete product.", "error");
            }
        }
    };

    return (
        <div className="mt-4">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
                <h6 className="fw-semibold mb-0">
                    <Icon
                        icon="mdi:factory"
                        className="menu-icon"
                        style={{ width: "30px", height: "30px" }}
                    />{" "}
                    | Product Details
                </h6>
                <ul className="d-flex align-items-center gap-2">
                    <li className="fw-medium">
                        <Link
                            to="/"
                            className="d-flex align-items-center gap-1 hover-text-primary"
                        >
                            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
                            Dashboard
                        </Link>
                    </li>
                    <li> - </li>
                    <li className="fw-medium">Product Details</li>
                </ul>
            </div>

            <div className="card">
                <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <div className="d-flex align-items-center gap-2">
                        <span>Show</span>
                        <select
                            className="form-select form-select-sm w-auto no-bg-position yearSelect"
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value={products.length}>All</option>
                        </select>
                    </div>
                    <div className="d-flex flex-column flex-lg-row align-items-center gap-6">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                        <button
                            className="btn fw-medium d-flex align-items-center gap-2 w-100 bg-custom"
                            onClick={() => navigate("/product/add")}
                        >
                            <Icon icon="mdi:plus" className="fs-5" />
                            Add New Product
                        </button>
                    </div>
                </div>

                <div className="card-body">
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="row g-4">
                            {paginatedProducts.length === 0 ? (
                                <div className="col-12 text-center py-5">No products found.</div>
                            ) : (
                                paginatedProducts.map((product, index) => (
                                    <div key={product._id || index} className="col-md-4">
                                        <div className="card h-100 shadow-sm prcard">
                                            <div className="position-relative">
                                                {product.image ? (
                                                    <img
                                                        src={`${product.image}`}
                                                        alt={product.product_name}
                                                        className="card-img-top"
                                                        style={{ height: "250px", objectFit: "cover" }}
                                                    />
                                                ) : (
                                                    <span
                                                        className="badge bg-secondary position-absolute top-50 start-50 translate-middle"
                                                        style={{ fontSize: "24px" }}
                                                    >
                                                        {product.product_name?.charAt(0).toUpperCase() || "?"}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="card-body d-flex flex-column justify-content-between">
                                                <div>
                                                    <h6 className="card-title">{product.product_name}</h6>
                                                    <p className="card-text mb-1">INR {product.main_price}</p>
                                                </div>
                                                <div className="d-flex gap-2 mt-2 overlaybtn">
                                                    <button
                                                        onClick={() => navigate(`/product/edit-product-details/${product.product_id}`)}
                                                        className="w-32-px h-32-px bg-warning-subtle rounded-circle d-inline-flex align-items-center justify-content-center border-0"
                                                    >
                                                        <Icon icon="mdi:pencil-outline" className="fs-5" />
                                                    </button>
                                                    <button
                                                        onClick={() => handleDeleteProduct(product.product_id)}
                                                        className="w-32-px h-32-px bg-danger-subtle text-danger rounded-circle d-inline-flex align-items-center justify-content-center border-0"
                                                    >
                                                        <Icon icon="mdi:delete-outline" className="fs-5" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    )}

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div className="d-flex justify-content-end align-items-center gap-4 mt-3">
                            <button
                                className="btn btn-sm btn-primary"
                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                Prev
                            </button>
                            <span>
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                className="btn btn-sm btn-primary"
                                onClick={() =>
                                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                                }
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductDetails;
